'use client'

// Wallet hooks and utilities
export { useChainSpecificWallet } from './useChainSpecificWallet'
export { useWallet } from './utils/useWallet'
export { useDynamicGasSponsorship } from './useDynamicGasSponsorship'
export { usePimlicoGaslessWallet } from './usePimlicoGaslessWallet'
export { usePrivySmartWallet } from './usePrivySmartWallet'

// Utilities and hooks
export { getIconByName } from './utils'

// Configuration and chains
export * from './chains'
export { default as config } from './config'
export * from './config'

// Gas sponsorship configuration
export * from './config/gasSponsorship'

// Types and constants
export enum ConnectorName {
  Injected = 'Injected',
  WalletConnect = 'WalletConnect',
  Privy = 'Privy Wallet',
}
